!(function(global){
	function SocialButtons(wrapper){
		if (!window.location.origin) {
			window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
		}

		this.wrapper = wrapper;
		this.url = this.wrapper.attr('data-url') || window.location.origin + window.location.pathname;


		_.each(this.wrapper.getChildrens('a'), function(item){
			item = _dom(item);
			switch (item.attr('data-provider')){
				case 'twitter':
					this._bindTwitter(item);
					break;
				case 'facebook':
					this._bindFacebook(item);
					break;
				case 'pinterest':
					this._bindPinterest(item);
					break;
				case 'googlePlus':
					this._bindGooglePlus(item);
					break;
				default:
					break;
			}
		}, this);

	}

	SocialButtons.prototype._bindTwitter = function(elButton){

		var message = elButton.attr('data-message') || '';

		elButton.attr('href', 'https://twitter.com/intent/tweet?text=' + message + '&url=' + this.url);


		_.each(elButton.getChildrens('span'), function(item){
          	item = _dom(item);
			if(item.attr('class') === 'socialCounter'){
				_ajax({
					type: 'JSONP',
					url: 'http://cdn.api.twitter.com/1/urls/count.json?url=' + this.url,
					success: function(json){
						item.setText(json.count);
					}
				});
			}
		}, this);

	};
	SocialButtons.prototype._bindFacebook = function(elButton){

		elButton.attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + this.url);

		_.each(elButton.getChildrens('span'), function(item){
          	item = _dom(item);
			if(item.attr('class') === 'socialCounter'){
				_ajax({
					type: 'JSONP',
					dataType: 'json',
					url: 'https://graph.facebook.com/fql?q=SELECT%20total_count%20FROM%20link_stat%20WHERE%20url=\'' + this.url + '\'',
					success: function(json){
						item.setText(json.data[0].total_count);
					}
				});
			}
		}, this);

	};
	SocialButtons.prototype._bindPinterest = function(elButton){

		var media = elButton.attr('data-media') || '',
			description = elButton.attr('data-description') || '';



		elButton.attr('href', 'http://www.pinterest.com/pin/create/button/' +
			'?url=' + this.url +
			'&media=' + media +
			'&description=' + description);


		_.each(elButton.getChildrens('span'), function(item){
          	item = _dom(item);
			if(item.attr('class') === 'socialCounter'){
				_ajax({
					type: 'JSONP',
					dataType: 'json',
					url: 'http://api.pinterest.com/v1/urls/count.json?url=' + this.url,
					success: function(json){
						item.setText(json.count);
					}
				});
			}
		}, this);

	};
	SocialButtons.prototype._bindGooglePlus = function(elButton){

		elButton.attr('href', 'https://plus.google.com/share?url=' + this.url);

		_.each(elButton.getChildrens('span'), function(item){
          	item = _dom(item);
			if(item.attr('class') === 'socialCounter'){
				_ajax({
					type: 'JSONP',
					url: 'http://api.sharedcount.com/?url=' + this.url,
					success: function(json){
						item.setText(json.GooglePlusOne);
					}
				});
			}
		}, this);

	};

	global.SocialButtons = SocialButtons;
})(window);